import React, { useState, useEffect } from "react";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../firebase";
import { SHOP } from "../shop";

export const THANK_YOU_DEFAULTS = {
  headline: "Vielen Dank für deine Rückmeldung!",
  subtext:
    "Wir haben dein Feedback erhalten und melden uns in Kürze bei dir.",
  nextStepsTitle: "Wie geht es weiter?",
  nextStepsBullets: [
    "Unser Team prüft dein Feedback innerhalb von 1–2 Werktagen.",
    "Wenn du Änderungen gewünscht hast, erstellen wir einen überarbeiteten " +
      "Entwurf und senden ihn dir zu.",
    "Wenn du den Entwurf freigegeben hast, starten wir direkt mit der Produktion.",
    "Du erhältst eine Bestätigungs-E-Mail mit einer Zusammenfassung deiner Einreichung.",
  ],
  footerNote:
    "Fragen? Antworte einfach auf die E-Mail, die du von uns erhalten hast.",
};

const ThankYouPage = ({ textConfig = null }) => {
  const [texts, setTexts] = useState(THANK_YOU_DEFAULTS);

  useEffect(() => {
    if (textConfig) {
      setTexts({ ...THANK_YOU_DEFAULTS, ...textConfig });
      return;
    }
    const load = async () => {
      const snap = await getDoc(doc(db, "config", "thankYouPage"));
      if (snap.exists()) {
        setTexts({ ...THANK_YOU_DEFAULTS, ...snap.data() });
      }
    };
    load();
  }, [textConfig]);

  return (
    <div style={{
      maxWidth: 560, margin: "4em auto", padding: "0 1em", textAlign: "center",
    }}>
      <div style={{
        background: "#fff", borderRadius: "10px",
        boxShadow: "0 1px 6px rgba(0,0,0,0.08)", padding: "2.5em 2em",
      }}>
        <img src={SHOP.logo} alt={SHOP.name}
          style={{ height: 84, display: "block", margin: "0 auto 0.75em" }} />
        <h2 style={{ margin: "0 0 0.5em", color: SHOP.primary, fontSize: "1.4rem" }}>
          {texts.headline}
        </h2>
        <p style={{ color: "#4a5568", marginBottom: "1.5em", lineHeight: "1.6" }}>
          {texts.subtext}
        </p>

        <div style={{
          background: SHOP.pageBg, borderRadius: "8px",
          padding: "1.25em 1.5em", textAlign: "left",
        }}>
          <p style={{
            margin: "0 0 0.5em", fontWeight: "700",
            color: "#2d3748", fontSize: "0.9rem",
          }}>
            {texts.nextStepsTitle}
          </p>
          <ul style={{
            margin: 0, paddingLeft: "1.25em",
            color: "#718096", fontSize: "0.875rem", lineHeight: "1.8",
          }}>
            {(texts.nextStepsBullets || []).map((b, i) => (
              <li key={i}>{b}</li>
            ))}
          </ul>
        </div>

        <p style={{ marginTop: "1.5em", color: "#a0aec0", fontSize: "0.85rem" }}>
          {texts.footerNote}
        </p>
      </div>
    </div>
  );
};

export default ThankYouPage;
